<template>
  <span class="text-blue-grey flex items-center">
    <QIcon
      :name="sentiment.icon"
      size="18px"
      :style="{ color: sentiment.color }"
    />
    <StreemTooltip>{{
      $t("social_mention_engagement_sentiment.automatically_rated_as", {
        sentiment: sentiment.label,
      })
    }}</StreemTooltip>
  </span>
</template>

<script>
import { sentimentOptions } from "shared/components/core/pickers/SentimentPicker";

export default {
  name: "SocialMentionEngagementSentiment",
  props: {
    modelValue: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    sentiment() {
      return sentimentOptions.find((option) => option.inRange(this.modelValue));
    },
  },
};
</script>
